import { useState } from "react";
import { useFormContext } from "react-hook-form";

interface useScheduleHourNotesHookProps {
  isPickupOrDelivery?: string;
  hoursFromKey?: string;
  hoursToKey?: string;
  notesKey?: string;
}

export default function useScheduleHourNotesHook({
  isPickupOrDelivery,
  hoursFromKey,
  hoursToKey,
  notesKey,
}: useScheduleHourNotesHookProps) {
  const { getValues, unregister } = useFormContext();

  const key = isPickupOrDelivery === "pickup" ? "pickup" : "delivery";
  const finalHoursFromKey = hoursFromKey ?? `schedule.${key}_hours_from`;
  const finalHoursToKey = hoursToKey ?? `schedule.${key}_hours_to`;
  const finalNotesKey = notesKey ?? `schedule.${key}_notes`;

  const hasHours = getValues(finalHoursFromKey) || getValues(finalHoursToKey);
  const hasNotes = getValues(finalNotesKey);

  const [showHour, setShowHour] = useState(Boolean(hasHours));
  const [showNotes, setShowNotes] = useState(Boolean(hasNotes));

  const handleShowHour = () => {
    setShowHour(!showHour);
    if (showHour) {
      unregister(finalHoursFromKey);
      unregister(finalHoursToKey);
    }
  };

  const handleShowNotes = () => {
    if (showNotes) {
      unregister(finalNotesKey);
    }
    setShowNotes(!showNotes);
  };

  return { showHour, showNotes, handleShowHour, handleShowNotes };
}
